import CONSTANTS from "./constants";

const urlPrefix = "/v2/course/student/address";
const urlPrefixPincode = "/v2/course/book/deliveryFee";
const apiEndPoints = {
  [CONSTANTS.SHIPMENT_ADDRESSLIST_GET]: {
    url: (data) => {
      return `${urlPrefix}?isphyscialDeliveryEnabled=${data?.isPhysical}`;
    },
    method: "GET",
  },
  [CONSTANTS.SHIPMENT_ADDRESSDATA_POST]: {
    url: () => `${urlPrefix}`,
    method: "POST",
  },
  [CONSTANTS.SHIPMENT_EDITADDRESSDATA_PUT]: {
    url: ({ addressId }) => `${urlPrefix}/${addressId}`,
    method: "PUT",
  },
  [CONSTANTS.SHIPMENT_DELETEADDRESSDATA_DELETE]: {
    url: ({ addressId }) => `${urlPrefix}/${addressId}`,
    method: "DELETE",
  },
  [CONSTANTS.SHIPMENT_SERVICEABLE]: {
    url: (data) =>
      `${urlPrefixPincode}/?pinCode=${data?.pincode}&isDeliveryFeeHandledByTutor=${data?.isDeliveryFeeHandledByTutor}`,
    method: "GET",
  },
};

export default apiEndPoints;
